module.exports = __webpack_public_path__ + "static/yildiz-entegre-2-742a5f228144cde57ff8b56ce1266b06.png";